module.exports = __webpack_public_path__ + "components/country-flag/static/ni-93f140ab770b4e3f70c64666c2b9c10b.svg";